const LastEducationOptions = () => [
  { label: 'Tidak Sekolah', value: 'NoFormalEducation' },
  { label: 'SD', value: 'ElementarySchool' },
  { label: 'SMP', value: 'JuniorHighSchool' },
  { label: 'SMA', value: 'SeniorHighSchool' },
  { label: 'SMK', value: 'VocationalHighSchool' },
  { label: 'D1', value: 'Diploma1' },
  { label: 'D2', value: 'Diploma2' },
  { label: 'D3', value: 'Diploma3' },
  { label: 'D4', value: 'Diploma4' },
  { label: 'S1', value: 'Bachelor' },
  { label: 'S2', value: 'Master' },
  { label: 'S3', value: 'Doctorate' },
  { label: 'Lain-lain', value: 'Other' },
]

export default LastEducationOptions